// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer___dMWCo","header":"header___Qk_JH","LoginModalContentSize":"LoginModalContentSize___D6pbB","largeContentSize":"largeContentSize___tMPfh"};